var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStuRegister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59 70",
    style: {
      enableBackground: "new 0 0 59 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.3,16.9L42,1c-0.3-0.3-0.8-0.5-1.3-0.5H6.1c-3.3,0-5.9,2.7-5.9,5.9v57.8c0,3.3,2.7,5.9,5.9,5.9h47.1 c3.3,0,5.9-2.7,5.9-5.9V18.8c0-0.1,0-0.3,0-0.4C59.2,17.8,58.8,17.2,58.3,16.9z M52.8,16.7c-2.5,0-5.6,0.1-7.8,0.1 c-2,0-2.3-0.2-2.3-2.5c0-0.7,0-4.5-0.1-7.5L52.8,16.7z M55.5,64.2c0,1.2-1,2.3-2.3,2.3H6.1c-1.2,0-2.3-1-2.3-2.3V6.4 c0-1.2,1-2.3,2.3-2.3h32.8C39,7,39,13.3,39,14.3c0,4.3,1.8,6.2,6,6.2c3,0,7.8-0.1,10.4-0.1V64.2z M13,43H29c1,0,1.8-0.8,1.8-1.8 S30,39.4,29,39.4H13c-1,0-1.8,0.8-1.8,1.8S12,43,13,43z M45.7,47.8H13c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h32.7 c1,0,1.8-0.8,1.8-1.8S46.7,47.8,45.7,47.8z M11.2,32.8c0,1,0.8,1.8,1.8,1.8h32.7c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8H13 C12,30.9,11.2,31.8,11.2,32.8z M45.7,56.2H13c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h32.7c1,0,1.8-0.8,1.8-1.8S46.7,56.2,45.7,56.2z  M21.2,18.4c2-0.5,3.5-2.3,3.5-4.5c0-2.6-2.1-4.7-4.7-4.7c-2.6,0-4.7,2.1-4.7,4.7c0,2.2,1.5,4,3.5,4.5c-3.9,0.5-6.9,3.9-6.9,7.9h16 C28.1,22.3,25.1,19,21.2,18.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStuRegister);
export default __webpack_public_path__ + "static/media/stuRegister.4df8279d.svg";
export { ForwardRef as ReactComponent };